module.exports = __webpack_public_path__ + "static/img/4.271798d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/sp/4.png
// module id = 3IPe
// module chunks = 0